module.exports = __webpack_public_path__ + "img/diseno-web.f3e7415f.jpg";